import React from 'react';
import useTranslate from '../../../../../../customHooks/useTranslate';
import Icon from '../../../../../../muiComponents/Icon';
import Tooltip from '../../../../../../muiComponents/Tooltip';

interface IconBaseOccupancyProps {
    personNumber: number;
    standardOccupancy: number;
}
const IconBaseOccupancy = (props: IconBaseOccupancyProps) => {
    const { standardOccupancy } = props;
    const translate = useTranslate();

    return (
        <div className='flex gap-5 flex-align-center'>
            <Icon
                iconName='Home'
                styles={{
                    root: {
                        fontSize: 18,
                        paddingBottom: 2,
                    },
                }}
            />
            <div className='flex flex-align-center'>
                {Array.from({ length: standardOccupancy }).map((_, i) => {
                    return (
                        <Icon
                            key={i}
                            iconName='Person'
                            style={{
                                fontSize: 22,
                                color: 'var(--secondary-400)',
                            }}
                        />
                    );
                })}
            </div>
            <Tooltip
                title={`${standardOccupancy} ${translate(
                    standardOccupancy === 1 ? 'adult' : 'adults'
                )}`}
            >
                <span>
                    <Icon
                        iconName={'InfoOutlined'}
                        sx={{
                            color: '#ffc107',
                            width: '12px',
                            height: '12px',
                            cursor: 'pointer',
                            marginBottom: '8px',
                        }}
                    />
                </span>
            </Tooltip>
        </div>
    );
};

export default IconBaseOccupancy;
